import type { HandleChangeAnswerType } from '../model';
import type { AnswerUserType } from '~/model/AnswerUserType';
import Slider from 'rc-slider/lib/Slider';
import { useLayoutEffect } from 'react';
import { getIdFromUri } from '@/app/utils/entities/uri';
import { useFocus } from '~/hooks/useFocus';

export const VASTypeQuestion = ({
  answerUser,
  questionId,
  limit_min,
  limit_max,
  label_min,
  label_max,
  handleChangeAnswer,
  type,
  langValue,
  disabled = false,
}: VASTypeQuestionPropsType) => {
  const [handleRef, setHandleFocus] = useFocus();
  const middle
    = limit_min !== null
      && limit_max !== null
      && Math.floor((limit_min + limit_max) / 2);
  const handleId = `question-${getIdFromUri(questionId)}`;

  useLayoutEffect(() => {
    setHandleFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleRef.current]);

  const isUnanswered = !answerUser[questionId];

  return (
    <div className="vas" data-testid="vas">
      <div className="vas__labels">
        <span lang={langValue}>{label_min}</span>
        <span lang={langValue}>{label_max}</span>
      </div>
      <div className="vas__slider">
        <Slider
          className={`VAS ${type} ${isUnanswered ? 'unanswered' : ''}`}
          defaultValue={middle}
          value={
            answerUser[questionId] != null
              ? (answerUser[questionId].value as number)
              : middle
          }
          min={limit_min}
          max={limit_max}
          step={0.1}
          onChange={value => handleChangeAnswer(value, questionId, type)}
          handleRender={node => (
            <div
              {...node.props}
              style={node.props.style}
              id={handleId}
              ref={handleRef}
            />
          )}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export interface VASTypeQuestionPropsType {
  answerUser: AnswerUserType;
  questionId: string;
  limit_min: number;
  limit_max: number;
  label_min: string;
  label_max: string;
  handleChangeAnswer: HandleChangeAnswerType;
  type: string;
  langValue: string;
  disabled?: boolean;
}
